import React, { useState } from 'react';
import './CookieConsent.css';
import Cookies from 'universal-cookie';

const CookieConsent = () => {
  const cookies = new Cookies();
  const [acknowledged, setAcknowledged] = useState(cookies.get('acknowledged_cookies'));

  const setCookie = (name, value) => {
    cookies.set(name, value, { path: '/', expires: new Date(Date.now() + 365 * 86400 * 1000) });
  };

  const handleAcceptAll = () => {
    setCookie('acknowledged_cookies', true);
    setCookie('functionality_cookies', true);
    setCookie('targeting_cookies', true);
    setAcknowledged(true);
  };

  const handleEssentialOnly = () => {
    setCookie('acknowledged_cookies', true);
    setCookie('functionality_cookies', true);
    setAcknowledged(true);
  };

  if (acknowledged) return null;

  return (
    <div className="cc-banner">
      <div className="cc-inner">
        <div className="cc-content">
          <div className="cc-header">
            <svg className="cc-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#18181b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
            <span className="cc-title">We use cookies</span>
          </div>
          <p className="cc-text">
            We use cookies to ensure functionality and gather usage insights. Learn more on our <a href="/cookies">Cookie Policy</a> page.
          </p>
        </div>
        <div className="cc-actions">
          <button className="cc-btn cc-btn--secondary" onClick={handleEssentialOnly}>
            Essential only
          </button>
          <button className="cc-btn cc-btn--primary" onClick={handleAcceptAll}>
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
